import { render, staticRenderFns } from "./GeneralConsentModal.vue?vue&type=template&id=5cb09428"
import script from "./GeneralConsentModal.vue?vue&type=script&lang=js"
export * from "./GeneralConsentModal.vue?vue&type=script&lang=js"
import style0 from "./GeneralConsentModal.vue?vue&type=style&index=0&id=5cb09428&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports